import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getXeroSyncInvoiceURL,
  getXeroWritebackURL
} from "../utils/constants/apiEndPoints";
import { HTTP_STATUS_SUCCESS } from "../utils/constants/appConstants";
import privateAxios from "../utils/axiosPrivate";

const initialState = {
  xeroWritebackData: {},
  loading: false
};

const xerowritebackSlice = createSlice({
  name: "xeroWriteback",
  initialState,
  reducers: {
    setGetXeroWritebackData(state, action) {
      state.xeroWritebackData = action.payload;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    }
  }
});

export const fetchXeroWritebackApData = createAsyncThunk(
  "xeroWriteback/fetchXeroWritebackApData",
  async (payload, { dispatch }) => {
    const { id } = payload;
    try {
      dispatch(setLoading(true));
      const response = await privateAxios.get(getXeroWritebackURL(id));
      if (
        response.status === 200 &&
        response.data.status === HTTP_STATUS_SUCCESS
      ) {
        dispatch(setLoading(false));
        dispatch(setGetXeroWritebackData(response.data.data));
      } else return response;
    } catch {
      dispatch(setLoading(false));
    } finally {
      dispatch(setLoading(false));
    }
  }
);

export const fetchXeroSyncInvoiceData = createAsyncThunk(
  "xeroWriteback/fetchXeroSyncInvoiceData",
  async (_, { rejectWithValue }) => {
    try {
      const response = await privateAxios.post(getXeroSyncInvoiceURL);
      return response;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

export const { setGetXeroWritebackData, setLoading } =
  xerowritebackSlice.actions;
export default xerowritebackSlice.reducer;
